// Edit / delete (and any extra) buttons at the end of a table row: clear
// icons with a name on hover and for screen readers.
import React from "react";
import { Pencil, Trash2 } from "lucide-react";

export const ActionButton = ({ label, onClick, danger = false, children }) => (
  <button
    type="button"
    onClick={onClick}
    aria-label={label}
    title={label}
    className={`inline-flex h-8 w-8 items-center justify-center rounded-lg text-gray-500 transition-colors ${danger ? "hover:bg-red-50 hover:text-red-600" : "hover:bg-blue-50 hover:text-blue-600"}`}
  >
    {children}
  </button>
);

// editLabel/deleteLabel name the thing: "Edit event", "Delete event".
export default function RowActions({ onEdit, onDelete, editLabel = "Edit", deleteLabel = "Delete", children }) {
  return (
    <div className="flex items-center justify-end gap-1 md:justify-start">
      {children}
      {onEdit && (
        <ActionButton label={editLabel} onClick={onEdit}>
          <Pencil className="h-4 w-4" />
        </ActionButton>
      )}
      {onDelete && (
        <ActionButton label={deleteLabel} onClick={onDelete} danger>
          <Trash2 className="h-4 w-4" />
        </ActionButton>
      )}
    </div>
  );
}
